import { Component, Input, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DocumentItem } from '../document-models/document-item';
import { DocumentService } from 'src/services/document.service';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-cps-drug-summary-document',
  templateUrl: './cps-drug-summary-document.component.html',
  styleUrls: ['./cps-drug-summary-document.component.scss']
})
export class CpsDrugSummaryDocumentComponent implements OnInit {

  @Input() htmlElement: HTMLElement;
  @ViewChild('docWrapper') documentWrapperElement: ElementRef;
  public doc: DocumentItem;

  public contentLoaded = false;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(private documentService: DocumentService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.checkContentLoaded();
  }

  checkContentLoaded(): void {
    const thizz = this;
    this.documentService.getContentLoaded().pipe(takeUntil(this.destroy$)).subscribe(isLoaded => {
      thizz.contentLoaded = isLoaded;
      thizz.changeDetector.detectChanges();
    });
  }
}
